import * as React from "react";

import { searchLocations, setLocationOnServerSession } from "../locationRepo";

import { LocationResults } from "./LocationResults";
import { LocationSearchForm, searchIsNotEmpty } from "./LocationSearchForm";

// Combines the search form and results and
// controls the relationship between the two
export class LocationSearchComponent extends React.Component<
  {
    handleSelect: (item: SimpleLocation) => void;
  },
  {
    locations: Array<SimpleLocation>;
    params: LocationSearchParams;
    hasSearch: boolean;
  }
> {
  constructor(props: { handleSelect: (item: SimpleLocation) => void }) {
    super(props);

    this.state = {
      locations: [],
      params: {
        FacilityType: 0,
        StateSearchTerm: "",
        CitySearchTerm: "",
        NameSearchTerm: "",
      },
      hasSearch: false,
    };
  }

  async handleSearchChanges(params: LocationSearchParams): Promise<void> {
    let results: Array<SimpleLocation> = [],
      hasSearch = false;

    if (searchIsNotEmpty(params)) {
      results = await searchLocations(params);
      hasSearch = true;
    }

    this.setState({
      ...this.state,
      locations: results.sort((a, b) => {
        const nameA = a.Name;
        const nameB = b.Name;
        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        } else {
          return 0;
        }
      }),
      hasSearch: hasSearch,
    });
  }

  async handleSelect(item: SimpleLocation) {
    await setLocationOnServerSession(item.ID);
    this.props.handleSelect(item);
  }

  render() {
    const hasResults = this.state.locations.length > 0;

    return (
      <>
        <LocationSearchForm
          params={this.state.params}
          onSearchChange={this.handleSearchChanges.bind(this)}
        />

        {hasResults && (
          <LocationResults
            results={this.state.locations}
            handleSelect={this.handleSelect.bind(this)}
          />
        )}
        {this.state.hasSearch && !hasResults && <p>No Results Found</p>}
      </>
    );
  }
}
